import type { SVGProps } from "react";

type P = SVGProps<SVGSVGElement> & { size?: number };

function base({ size = 24, ...rest }: P) {
  return {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true,
    ...rest,
  };
}

export const IconPlus = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);
export const IconSearch = (p: P) => (
  <svg {...base(p)}>
    <circle cx="11" cy="11" r="6" />
    <path d="M20 20l-4.5-4.5" />
  </svg>
);
export const IconInbox = (p: P) => (
  <svg {...base(p)}>
    <path d="M4 13l2.5-7h11L20 13v5a1 1 0 01-1 1H5a1 1 0 01-1-1v-5z" />
    <path d="M4 13h4.5a3.5 3.5 0 007 0H20" />
  </svg>
);
export const IconToday = ({ day, ...p }: P & { day?: number }) => (
  <svg {...base(p)}>
    <rect x="4" y="5" width="16" height="15" rx="2" />
    <path d="M4 9h16" />
    <text x="12" y="17.5" textAnchor="middle" fontSize="8" fill="currentColor" stroke="none" fontWeight="600">
      {day ?? ""}
    </text>
  </svg>
);
export const IconUpcoming = (p: P) => (
  <svg {...base(p)}>
    <rect x="4" y="5" width="16" height="15" rx="2" />
    <path d="M4 9h16M8 3v3M16 3v3M8 13h2M12 13h2M16 13h0M8 16h2M12 16h2" />
  </svg>
);
export const IconFilters = (p: P) => (
  <svg {...base(p)}>
    <rect x="4" y="4" width="7" height="7" rx="1.5" />
    <rect x="13" y="4" width="7" height="7" rx="1.5" />
    <rect x="4" y="13" width="7" height="7" rx="1.5" />
    <rect x="13" y="13" width="7" height="7" rx="1.5" />
  </svg>
);
export const IconCompleted = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="8" />
    <path d="M8.5 12.5l2.5 2.5 4.5-5" />
  </svg>
);
export const IconHash = (p: P) => (
  <svg {...base(p)}>
    <path d="M10 4L8 20M16 4l-2 16M5 9h15M4 15h15" />
  </svg>
);
export const IconLabel = (p: P) => (
  <svg {...base(p)}>
    <path d="M4 12.5V5a1 1 0 011-1h7.5l7.5 7.5-8.5 8.5L4 12.5z" />
    <circle cx="8.5" cy="8.5" r="1.2" />
  </svg>
);
export const IconDrop = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 4c3 4 6 7 6 10a6 6 0 01-12 0c0-3 3-6 6-10z" />
  </svg>
);
export const IconCheck = (p: P) => (
  <svg {...base(p)}>
    <path d="M6 12.5l4 4 8-9" strokeWidth={2} />
  </svg>
);
export const IconChevronDown = (p: P) => (
  <svg {...base(p)}>
    <path d="M7 10l5 5 5-5" />
  </svg>
);
export const IconChevronRight = (p: P) => (
  <svg {...base(p)}>
    <path d="M10 7l5 5-5 5" />
  </svg>
);
export const IconChevronLeft = (p: P) => (
  <svg {...base(p)}>
    <path d="M14 7l-5 5 5 5" />
  </svg>
);
export const IconMore = (p: P) => (
  <svg {...base(p)}>
    <circle cx="6" cy="12" r="1" fill="currentColor" />
    <circle cx="12" cy="12" r="1" fill="currentColor" />
    <circle cx="18" cy="12" r="1" fill="currentColor" />
  </svg>
);
export const IconEdit = (p: P) => (
  <svg {...base(p)}>
    <path d="M14.5 5.5l4 4L9 19H5v-4l9.5-9.5z" />
  </svg>
);
export const IconCalendar = (p: P) => (
  <svg {...base(p)}>
    <rect x="4" y="5" width="16" height="15" rx="2" />
    <path d="M4 9h16M8 3v3M16 3v3" />
  </svg>
);
export const IconComment = (p: P) => (
  <svg {...base(p)}>
    <path d="M5 5h14v10H9l-4 4V5z" />
  </svg>
);
export const IconFlag = ({ filled, ...p }: P & { filled?: boolean }) => (
  <svg {...base(p)}>
    <path d="M6 20V5M6 5h10l-2 4 2 4H6" fill={filled ? "currentColor" : "none"} />
  </svg>
);
export const IconTrash = (p: P) => (
  <svg {...base(p)}>
    <path d="M5 7h14M10 7V5h4v2M7 7l1 12h8l1-12" />
  </svg>
);
export const IconClose = (p: P) => (
  <svg {...base(p)}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);
export const IconSidebar = (p: P) => (
  <svg {...base(p)}>
    <rect x="4" y="5" width="16" height="14" rx="2" />
    <path d="M10 5v14" />
  </svg>
);
export const IconDrag = (p: P) => (
  <svg {...base(p)}>
    <circle cx="9" cy="7" r="1" fill="currentColor" />
    <circle cx="15" cy="7" r="1" fill="currentColor" />
    <circle cx="9" cy="12" r="1" fill="currentColor" />
    <circle cx="15" cy="12" r="1" fill="currentColor" />
    <circle cx="9" cy="17" r="1" fill="currentColor" />
    <circle cx="15" cy="17" r="1" fill="currentColor" />
  </svg>
);
export const IconSubtask = (p: P) => (
  <svg {...base(p)}>
    <path d="M6 5v8a3 3 0 003 3h9M15 13l3 3-3 3" />
  </svg>
);
export const IconRepeat = (p: P) => (
  <svg {...base(p)}>
    <path d="M5 11V9a3 3 0 013-3h10l-3-3M19 13v2a3 3 0 01-3 3H6l3 3" />
  </svg>
);
export const IconBell = (p: P) => (
  <svg {...base(p)}>
    <path d="M6 16V11a6 6 0 0112 0v5l2 2H4l2-2zM10 20h4" />
  </svg>
);
export const IconTarget = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="8" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="12" cy="12" r="0.8" fill="currentColor" />
  </svg>
);
export const IconPaperclip = (p: P) => (
  <svg {...base(p)}>
    <path d="M16.5 7.5l-7 7a2 2 0 002.8 2.8l7.2-7.2a4 4 0 00-5.6-5.6L6.6 11.8a6 6 0 008.5 8.5L20 15.5" />
  </svg>
);
export const IconBoard = (p: P) => (
  <svg {...base(p)}>
    <rect x="4" y="5" width="4.5" height="14" rx="1" />
    <rect x="10" y="5" width="4.5" height="9" rx="1" />
    <rect x="16" y="5" width="4" height="11" rx="1" />
  </svg>
);
export const IconList = (p: P) => (
  <svg {...base(p)}>
    <path d="M9 7h11M9 12h11M9 17h11M5 7h0M5 12h0M5 17h0" strokeWidth={2} />
  </svg>
);
export const IconSliders = (p: P) => (
  <svg {...base(p)}>
    <path d="M5 7h8M17 7h2M5 17h2M11 17h8" />
    <circle cx="15" cy="7" r="2" />
    <circle cx="9" cy="17" r="2" />
  </svg>
);
export const IconUser = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="9" r="3.5" />
    <path d="M5 19a7 7 0 0114 0" />
  </svg>
);
export const IconHeart = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 19s-7-4.5-7-9.5A3.8 3.8 0 0112 7a3.8 3.8 0 017 2.5C19 14.5 12 19 12 19z" />
  </svg>
);
export const IconArchive = (p: P) => (
  <svg {...base(p)}>
    <rect x="4" y="5" width="16" height="4" rx="1" />
    <path d="M5 9v9a1 1 0 001 1h12a1 1 0 001-1V9M10 13h4" />
  </svg>
);
export const IconArrowUp = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 19V5M6 11l6-6 6 6" />
  </svg>
);
export const IconArrowDown = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 5v14M6 13l6 6 6-6" />
  </svg>
);
export const IconLogo = ({ size = 24 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
    <rect width="32" height="32" rx="8" fill="#DC4C3E" />
    <path
      d="M9 16.5l4.5 4.5L23 11.5"
      fill="none"
      stroke="#fff"
      strokeWidth="3.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
